export default "__VITE_ASSET__B7QudF5W__"